/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/LastModified/Content"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let eventActionUpdatedByUserVaxiomUserValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'updated_by_user.vaxiom_user',
})
let eventActionUpdatedAtValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'updated_at',
})
let aggregateData = fromHelpers.getText(eventActionUpdatedByUserVaxiomUserValueData, eventActionUpdatedAtValueData)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral500}
 data="event_action.updated_by_user.vaxiom_user"
 data="event_action.updated_at"
 aggregate="helpers.js getText"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}